import Swal from "sweetalert2";

const deleteAlert = (task)=>Swal.fire({
    title: "Are you sure?",
    text: `You wanna delete '${task}...'`,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#5d8bf4",
    cancelButtonColor: "#0f172a",
    confirmButtonText: "Yes, delete it!",
    background: "#f1f0ff",
  });

const allClear = ()=> Swal.fire({
    title: "Hooray🎉You have completed your all tasks🎇",
    width: 600,
    padding: "3em",
    color: "#5d8bf4",
    background: "#f1f0ff",
    imageUrl:
      "https://media.giphy.com/media/WZkr0YCuLiCSBAQsym/giphy.gif",
    imageWidth: 300,
    imageHeight: 300,
    imageAlt: "Custom image",
    backdrop: `
    #0f172ac4
  `,
  })

const deletionDone = ()=> Swal.fire({
    title: "Deleted!",
    text: "Your Task has been deleted.",
    icon: "success",
    background: "#f1f0ff",
    confirmButtonColor: "#5d8bf4",
  })

export {deleteAlert, allClear, deletionDone};